var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import { Swiper, SwiperSlide } from "swiper/react";
import Loader from "../../../Loader";
import GameCard from "../GameCard";
import { CardBody, MoreButton } from "../styles";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.min.css";
var swiperConfig = {
    spaceBetween: 5,
    slidesPerView: 1.07,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
};
var messages = defineMessages({
    more: {
        id: "games.More",
        defaultMessage: "Еще",
    },
});
var GamesSwiper = /** @class */ (function (_super) {
    __extends(GamesSwiper, _super);
    function GamesSwiper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.swiperRef = React.createRef();
        _this.state = {
            activeIndex: 0,
            windowWidth: typeof window !== "undefined" ? window.innerWidth : 1200,
        };
        _this.handleResize = function () {
            _this.setState({ windowWidth: window.innerWidth });
        };
        _this.getMaxGamesPerGroup = function () {
            var width = _this.state.windowWidth;
            if (width >= 1200)
                return 7;
            if (width >= 769)
                return 4;
            if (width >= 481)
                return 4;
            return 4;
        };
        _this.getGridRepeatColums = function () {
            var width = _this.state.windowWidth;
            if (width >= 1200)
                return 7;
            if (width >= 769)
                return 4;
            if (width >= 689)
                return 3;
            return 2;
        };
        _this.formatGamesForSwiper = function (games) {
            var gamesForSwiper = [];
            var localGamesGroup = [];
            games.forEach(function (game) {
                if (localGamesGroup.length < _this.getMaxGamesPerGroup())
                    localGamesGroup.push(game);
                else {
                    gamesForSwiper.push(localGamesGroup);
                    localGamesGroup = [game];
                }
            });
            if (localGamesGroup.length)
                gamesForSwiper.push(localGamesGroup);
            return gamesForSwiper;
        };
        _this.handleSlideChange = function (swiper) {
            _this.setState({ activeIndex: swiper.activeIndex });
        };
        _this.goToSlide = function (index) {
            if (_this.swiperRef.current) {
                _this.swiperRef.current.swiper.slideTo(index);
            }
        };
        return _this;
    }
    GamesSwiper.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.handleResize);
    };
    GamesSwiper.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.handleResize);
    };
    GamesSwiper.prototype.render = function () {
        var _this = this;
        var _a = this.props, intl = _a.intl, darkTheme = _a.darkTheme, games = _a.games, isLoading = _a.isLoading, getMore = _a.getMore;
        var activeIndex = this.state.activeIndex;
        return (_jsxs("div", { children: [isLoading && _jsx(Loader, {}), _jsx(Swiper, __assign({}, swiperConfig, { onSlideChange: this.handleSlideChange, ref: this.swiperRef }, { children: this.formatGamesForSwiper(games).map(function (game, idx, allGames) {
                        var isLast = idx === allGames.length - 1;
                        var maxPerGroup = _this.getMaxGamesPerGroup();
                        var gridCols = _this.getGridRepeatColums();
                        var gameCount = game.length;
                        var isLastColumn = gameCount === maxPerGroup || gameCount >= gridCols;
                        var isFullHeight = gameCount !== 1 && gameCount !== maxPerGroup / 2;
                        return (_jsx(SwiperSlide, { children: _jsxs(CardBody, { children: [game.map(function (gameDetail) { return (_jsx(GameCard, { game: gameDetail }, gameDetail.Id)); }), isLast && (_jsxs(MoreButton, __assign({ darkTheme: darkTheme, style: {
                                            gridColumn: isLastColumn ? -1 : undefined,
                                            gridRow: isFullHeight ? "1 / 3" : undefined,
                                        }, onClick: getMore }, { children: [intl.formatMessage(messages.more), _jsx("div", { className: "arrow-right ".concat(darkTheme ? "dark" : "") })] })))] }) }, idx));
                    }) })), _jsx("div", __assign({ className: "custom-pagination" }, { children: this.formatGamesForSwiper(games).map(function (_, idx) { return (_jsx("span", { className: "pagination-dot ".concat(activeIndex === idx ? "active" : ""), onClick: function () { return _this.goToSlide(idx); } }, idx)); }) }))] }));
    };
    return GamesSwiper;
}(React.Component));
var mapStateToProps = function (state) {
    var _a = state.games.openGame, isLoading = _a.isLoading, error = _a.error;
    return {
        error: error,
        user: state.auth.user,
        langId: state.application.get("languageId"),
        darkTheme: state.application.get("darkTheme"),
        isLoading: isLoading,
    };
};
export default injectIntl(connect(mapStateToProps)(GamesSwiper));



// WEBPACK FOOTER //
// ./src/components/games/components/GamesSwiper/GamesSwiper.jsx